module.exports = __webpack_public_path__ + "videos/vps-video.c4242f0.mp4";